<script lang="ts">
  import PreLoginHeader from "../components/pre-login/PreLoginHeader.svelte";
  import PreLoginHeroSection from "../components/pre-login/PreLoginHeroSection.svelte";
</script>

<main>
  <PreLoginHeader />
  <PreLoginHeroSection />
</main>
